import { Component } from 'react';

import API from '../../../../utils/API';
import FieldModal from '../../../../components/modals/fieldModal';

import 'react-toggle/style.css';
import ViewsTable from '../../../../components/tables/ViewsTable';
import InputField from '../../../../components/inputs/inputField';

class InventoryAddSessionsModal extends Component {
    constructor(props) {
        super(props);
        const columns = {
            name: 'Session Name',
            locationName: 'Location Name',
        };
        const columnTypes = {
            name: 'text',
            location: 'text',
        };
        const columnWidth = {
            firstName: 150,
            lastName: 150,
            email: 200
        };
        const toggledColumns = {};
        const normalizedColumns = Object.keys(columns).map((cfc) => {
            toggledColumns[cfc] = true;
            return {
                label: columns[cfc],
                key: cfc,
                value: cfc,
                type: columnTypes[cfc],
                sortAsc: false,
                sortDesc: false
            };
        });

        this.state = {
            orgId: props.orgId,
            eventId: props.eventId,
            checkedSessions: {},
            searchedSessions: [],
            allChecked: false,
            searchSelected: false,
            searching: false,
            searchTerm: '',
            searchField: '',
            loading: false,
            submitting: false,
            columns: columns,
            columnTypes: columnTypes,
            normalizedColumns: normalizedColumns,
            toggledColumns: toggledColumns,
            columnWidth: columnWidth,
            selectedColumnSort: null,
            sortDesc: false
        };
    }


    filterSessions = (sessions) => {
        return sessions.filter((a) => !this.props.existingSessions.find((at) => at._id == a._id));
    };


    toggleSearch = () => {
        this.setState({ searchSelected: !this.state.searchSelected });
    };

    addSessions = async (sessions) => {
        const { group } = this.props;
        this.setState({ submitting: true });
        const { eventId, orgId, editedItem } = this.props;
        await API()
            .patch(`Organizations/${orgId}/events/${eventId}/inventory/${editedItem._id}`, {
                name: editedItem.name,
                bookedBy: sessions,
                request: 'addBookedBy'
            })
            .then((res) => {
                if (res.data) {
                    //this.props.addSessions(sessions.map((a) => this.props.sessions.find((at) => at._id == a)));
                    //this.props.toggle();
                    let allSessions = this.props.sessions;
                    let sessionObjects = allSessions.filter((a) => sessions.includes(a._id)).map((a) => {
                        return {
                            _id: a._id,
                            name: a.name,
                        };
                    });
                    this.props.addBookedBySessions(sessionObjects);
                    this.props.toggle();
                }
            });
    };


    updatedCheckedSessions = (checked) => {
        this.setState({ checkedSessions: checked });
    };

    sortData = (column, sortAsc, sortDesc) => {
        const { normalizedColumns } = this.state;
        const updatedColumns = normalizedColumns.map((col) => {
            if (col.key == column.key) {
                col.sortAsc = sortAsc;
                col.sortDesc = sortDesc;
            } else {
                col.sortAsc = false;
                col.sortDesc = false;
            }
            return col;
        });

        this.setState({
            normalizedColumns: updatedColumns,
            selectedColumnSort: column,
            sortDesc: sortDesc ? true : false
        });
    };

    render() {
        const {
            loading,
            submitting,
            checkedSessions,
            columnWidth,
            normalizedColumns,
            toggledColumns,
            selectedColumnSort,
            sortDesc,
            searchTerm,
            columns
        } = this.state;
        const { sessions, isOpen, toggle } = this.props;
        let availableSessions = this.filterSessions(sessions);
        console.log(availableSessions);
        
        let data = availableSessions;
        if (searchTerm.length > 0) {
            const searchTerms = searchTerm.toLowerCase().split(' ');
            searchTerms.forEach((term) => {
                if (term != '') {
                    data = data.filter((entry) => {
                        let found = false;
                        Object.keys(columns).forEach((key) => {
                            if (term != '' && entry[key] && entry[key].toString().toLowerCase().includes(term)) {
                                found = true;
                            }
                        });
                        return found;
                    });
                }
            });
        }
        if (selectedColumnSort) {
            data = availableSessions.sort((a, b) => {
                const columnType = selectedColumnSort.type || typeof a[selectedColumnSort.key];
                if (a[selectedColumnSort.key] && b[selectedColumnSort.key]) {
                    switch (columnType) {
                        case 'string':
                            return a[selectedColumnSort.key]
                                .toLowerCase()
                                .trim()
                                .localeCompare(b[selectedColumnSort.key].toLowerCase().trim());
                        case 'number':
                            return a[selectedColumnSort.key] - b[selectedColumnSort.key];
                        case 'date':
                            return (
                                new Date(a[selectedColumnSort.key]).getTime() -
                                new Date(b[selectedColumnSort.key]).getTime()
                            );
                        case 'time':
                            return (
                                new Date(a[selectedColumnSort.key]).getTime() -
                                new Date(b[selectedColumnSort.key]).getTime()
                            );
                        case 'boolean':
                            const a1 = a[selectedColumnSort.key] ? 'yes' : 'no';
                            const b1 = b[selectedColumnSort.key] ? 'yes' : 'no';
                            return a1.localeCompare(b1);
                        default:
                            return a[selectedColumnSort.key]
                                .toLowerCase()
                                .trim()
                                .localeCompare(b[selectedColumnSort.key].toLowerCase().trim());
                    }
                } else if (a[selectedColumnSort.key]) {
                    return 1;
                }
                return -1;
            });

            availableSessions = sortDesc ? availableSessions.reverse() : availableSessions;
        }
        return (


            <div>
                <FieldModal
                    size="large"
                    isOpen={isOpen}
                    modalTitle={"Add Sessions to Inventory Item"}
                    bodyHeaderText={''}
                    bodyDescription={''}
                    bodyContent={() => {
                        return (
                            <div>
                                <InputField
                                    classes="viewSearch"
                                    placeholder="Search "
                                    clickIcon={true}
                                    required={true}
                                    value={searchTerm}
                                    onChange={(e) => {
                                        clearTimeout(this.searchTimeout);
                                        this.setState({ searchTerm: e.target.value });
                                    }}
                                    prefix={<i className="las la-search" style={{ marginRight: 5, transform: 'rotate(270deg)' }} />}
                                    inputIcon={searchTerm !== '' &&
                                        <i
                                            onMouseDown={() => this.setState({ searchTerm: '', searching: false })}
                                            //onClick={() => this.setState({ searchTerm: '', searching: false })}
                                            className="las la-times-circle"
                                            style={{ visibility: searchTerm == '' ? 'hidden' : 'visible' }}
                                        />}
                                />
                                <ViewsTable
                                    title="Sessions"
                                    style={{ margin: 0, height: 'calc(100vh - 350px)' }}
                                    classes={"fit"}
                                    columns={normalizedColumns}
                                    toggledColumns={toggledColumns}
                                    data={data}
                                    mainColumnActive={false}
                                    columnWidth={columnWidth}
                                    checked={this.state.checkedSessions}
                                    checkRow={(entryId) => {
                                        const checked = this.state.checkedSessions;
                                        checked[entryId] ? delete checked[entryId] : (checked[entryId] = true);
                                        this.updatedCheckedSessions(checked);
                                    }}
                                    checkAllRows={(entryIds) => {
                                        let checked = this.state.checkedSessions;
                                        entryIds.length > 0
                                            ? entryIds.forEach((entryId) => {
                                                checked[entryId] = true;
                                            })
                                            : (checked = {});
                                        this.updatedCheckedSessions(checked);
                                    }}
                                    sortData={this.sortData}
                                />{' '}
                                <p style={{ width: 200,  paddingTop: 10  }} className="small gray mb-0 mr-25">
                                {Object.keys(this.state.checkedSessions || {}).length} selected out of {data.length || 0} record
                                {data.length === 1 ? "" : "s"}
                                </p>
                            </div>)
                    }}
                    toggle={toggle}
                    actionButtonLabel={!submitting ? 'Submit' : 'Adding...'}
                    checkedEntryCount={checkedSessions}
                    entryTable={availableSessions}
                    actionButton={() => {

                        this.setState({ submitting: true });
                        if (Object.keys(checkedSessions).length > 0) {
                            this.addSessions(Object.keys(checkedSessions));
                        } else {
                            this.setState({ invalid: true, submitting: false });
                        }
                    }}
                    actionButtonDisabled={submitting}
                    isFullWidthBody={true}
                ></FieldModal>
            </div>

        );
    }
}

export default InventoryAddSessionsModal;
